// src/config.js
export const BASE_URL = 'https://app-herminio-blackman-server-4316.onrender.com'; //PRD
// export const BASE_URL = 'https://app-herminio-blackman-server-1.onrender.com'; //DEV
//export const BASE_URL = 'http://localhost:8080'; //LOCAL